module.exports = __webpack_public_path__ + "static/img/The Hierophant.5034f85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The Hierophant.jpg
// module id = 1315
// module chunks = 0